import {
  Call,
  ApiUrl,
  PageParams,
  ParseGeneralResponse,
  setObjectToFormData,
} from './ApiUtils'
import AppConfig from '../config/AppConfig'
import { isEmpty } from '../common/Common'
import I18n from '../common/I18n'

export const RulesApi = {
  fetch: (organization_id) => {
    // The rules index action keys on `org_id` (not organization_id). Call() only
    // auto-appends org_id for non-super-admins, so super-admin callers (e.g. the
    // Organizations → Configurations screen) must pass it explicitly or the
    // endpoint 422s. Harmless for org-admins — Call() de-dupes org_id.
    const url = ApiUrl(
      `v2/rules?organization_id=${organization_id}&org_id=${organization_id}&operation_code=OCNFR`,
    )
    return Call('get', url, {}, ParseGeneralResponse, {
      responseDataKeys: { organization_rules: 'rules' },
    })
  },
  save: (data) => {
    const url = ApiUrl('v2/rules')
    return Call('post', url, data, ParseGeneralResponse, {
        responseDataKeys: {
        organization_rule: 'organization_rule',
        message: 'message',
        },
    })
  },
  update: (data) => {
    const url = ApiUrl('v2/rules/update_rules')
    return Call('put', url, data, ParseGeneralResponse, {
        responseDataKeys: {
        organization_rule: 'organization_rule',
        message: 'message',
        },
    })
  }
}

export const SubjectLines = {
  save: (data) => {
    const url = ApiUrl("v2/organization/update_org_config");
    return Call("put", url, data, ParseGeneralResponse, {
      responseDataKeys: { data: "org_config_setting" },
    });
  },
};

export const InvoicePodMapping = {
  getMapping: (organization_id) => {
    const url = ApiUrl(
      `v2/organization/invoice_pod_mapping?organization_id=${organization_id}`
    );
    return Call("GET", url, {}, ParseGeneralResponse, {
      responseDataKeys: { accounts: "accounts", system_tags: "system_tags" },
    });
  },
  saveMapping: (data) => {
    const url = ApiUrl("v2/organization/save_invoice_pod_mapping");
    return Call("POST", url, data, ParseGeneralResponse, {
      responseDataKeys: { message: "message", warnings: "warnings" },
    });
  },
};

export const RemmitanceMapping = {
  saveMappingDetails: (data) => {
    const url = ApiUrl("v2/csv_column_mappings/remittance_export_file_mapping");
    return Call("POST", url, data, ParseGeneralResponse, {
      responseDataKeys: { message: "message" },
    });
  },
  getMappingDetails: (data) =>{
    const {organization_id} = data
    const url = ApiUrl(
      `v2/csv_column_mappings/remittance_file_mapping_index?organization_id=${organization_id}`
    );
    return Call("GET", url, {}, ParseGeneralResponse, {
      responseDataKeys: { columnMappings: "column_mappings" },
    });
  }
};
